import React from "react";
import * as C from "./styles";

export default function LoadingPage() {
  document.title = "Carregando | GSA Business Intelligence";

  React.useEffect(()=>{
    return ()=>{
      document.title = 'GSA Business Intelligence'
    }
  },[])

  return (
    <C.Container>
      
      <C.LoadingAnimation src="/images/gifs/loading-animation.gif" />
    </C.Container>
  );
}
